// extracted by mini-css-extract-plugin
export default {"OwnerReportContent":"OwnerReport_OwnerReportContent__m97u7","teamTitle":"OwnerReport_teamTitle__d6GV0","backBtn":"OwnerReport_backBtn__SSMEq"};